import { AccordionItem as FASTAccordionItem } from '@microsoft/fast-components';
import { foundationAccordionItemStyles as styles } from './accordion-item.styles';
import { foundationAccordionItemTemplate as template } from './accordion-item.template';
/**
 * @tagname %%prefix%%-accordion-item
 */
export class AccordionItem extends FASTAccordionItem {
}
export const foundationAccordionItemShadowOptions = {
    delegatesFocus: true,
    mode: 'open',
};
export const defaultAccordionItemConfig = {
    collapsedIcon: `<svg width="16" height="16" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" slot="collapsed-icon">
    <path d="M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z" stroke-linecap="round" stroke-linejoin="round"></path>
    <path class="plus-sign" d="M9 5.44446V12.5556" stroke-linecap="round" stroke-linejoin="round"></path>
    <path class="plus-sign" d="M5.44446 9H12.5556" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>`,
    expandedIcon: `<svg width="16" height="16" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" slot="expanded-icon">
    <path d="M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z" stroke-linecap="round" stroke-linejoin="round"></path>
    <path class="minus-sign" d="M5.44446 9H12.5556" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>`,
};
/**
 * The Foundation Accordion Item
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-accordion-item\>
 */
export const foundationAccordionItem = AccordionItem.compose(Object.assign({ baseName: 'accordion-item', template,
    styles, shadowOptions: foundationAccordionItemShadowOptions }, defaultAccordionItemConfig));
